(function() {
  var __blocks__ = {};
  (function() {
    var element = document.getElementById("blocks-script");
    var attribute = a = element ? element.getAttribute("data-blocks") : '';
    var blocks = a.split(",").filter(Boolean);

    for (var i = 0; i < blocks.length; i++) {
      __blocks__[blocks[i]] = true;
    }
  })();
  (function() {
  if (!__blocks__["pdp-flavor-selector"] && !Shopify.designMode) return;
  try {
    (() => {
    const getCheckedValue = (root) => {
      const checkedRadio = root.querySelector('variant-picker input[type="radio"]:checked');
      if (checkedRadio && checkedRadio.value) return checkedRadio.value;

      const selectedOption = root.querySelector('variant-picker select option:checked');
      if (selectedOption && selectedOption.value) return selectedOption.value;

      return '';
    };

    const selectFlavorInPicker = (root, value) => {
      const radios = Array.from(root.querySelectorAll('variant-picker input[type="radio"]'));
      const radioMatch = radios.find((input) => input.value === value && !input.disabled);
      if (radioMatch) {
        radioMatch.click();
        radioMatch.dispatchEvent(new Event('change', { bubbles: true }));
        return;
      }

      const selects = Array.from(root.querySelectorAll('variant-picker select'));
      for (const select of selects) {
        const option = Array.from(select.options).find((item) => item.value === value && !item.disabled);
        if (option) {
          select.value = option.value;
          select.dispatchEvent(new Event('change', { bubbles: true }));
          break;
        }
      }
    };

    const mobileQuery = window.matchMedia('(max-width: 749px)');

    const initSelector = (selector) => {
      const scope = selector.closest('.product-details') || selector.closest('section') || document;
      const buttons = Array.from(selector.querySelectorAll('[data-flavor-value]'));

      if (buttons.length === 0) return;

      // Mobile bottom-bar: reserve page space for the fixed bar and wire the toggle.
      document.body.classList.add('has-pdp-flavor-bar');

      const toggles = Array.from(selector.querySelectorAll('[data-flavor-toggle]'));
      const setOpen = (open) => {
        selector.classList.toggle('is-open', open);
        toggles.forEach((toggle) => toggle.setAttribute('aria-expanded', open ? 'true' : 'false'));
      };

      // After picking a flavor on mobile, bring the main product image into view.
      const scrollToMainImage = () => {
        const section = selector.closest('.shopify-section') || document;
        const gallery = section.querySelector('media-gallery') || document.querySelector('media-gallery');
        if (!gallery) return;
        const header = document.querySelector('.hyde-header-section');
        const headerHeight = header ? header.getBoundingClientRect().height : 0;
        const top = gallery.getBoundingClientRect().top + window.scrollY - headerHeight - 8;
        window.scrollTo({ top: Math.max(top, 0), behavior: 'smooth' });
      };

      toggles.forEach((toggle) => {
        toggle.addEventListener('click', (event) => {
          event.stopPropagation();
          setOpen(!selector.classList.contains('is-open'));
        });
      });

      // Tap outside the sheet closes it.
      document.addEventListener('click', (event) => {
        if (selector.classList.contains('is-open') && !selector.contains(event.target)) {
          setOpen(false);
        }
      });

      document.addEventListener('keydown', (event) => {
        if (event.key === 'Escape') setOpen(false);
      });

      // Suppress product image swap when the change originates from this selector.
      // Strip <media-gallery> out of the incoming HTML doc so MediaGallery#handleVariantUpdate bails early.
      // Price, SKU, inventory, form-state listeners still receive the event normally.
      let suppressMediaSwap = false;
      scope.addEventListener(
        'variant:update',
        (event) => {
          if (!suppressMediaSwap) return;
          suppressMediaSwap = false;
          const doc = event.detail && event.detail.data && event.detail.data.html;
          if (doc && typeof doc.querySelectorAll === 'function') {
            doc.querySelectorAll('media-gallery').forEach((node) => node.remove());
          }
        },
        true,
      );

      const updateUi = () => {
        const liveValue = getCheckedValue(scope) || selector.dataset.initialFlavor || '';

        buttons.forEach((button) => {
          const active = button.dataset.flavorValue === liveValue;
          button.classList.toggle('is-active', active);
          button.setAttribute('aria-pressed', active ? 'true' : 'false');
        });
      };

      buttons.forEach((button) => {
        button.addEventListener('click', () => {
          const value = button.dataset.flavorValue;
          if (!value) return;
          selector.dataset.initialFlavor = value;
          suppressMediaSwap = true;
          selectFlavorInPicker(scope, value);
          updateUi();
          if (mobileQuery.matches) {
            setOpen(false);
            scrollToMainImage();
          }
        });
      });

      scope.addEventListener('change', (event) => {
        if (event.target.closest('variant-picker')) {
          updateUi();
        }
      });

      updateUi();
    };

    const selectors = document.querySelectorAll('.pdp-flavor-selector');
    selectors.forEach(initSelector);
  })();
  } catch(e) { console.error(e); }
})();

})();
